export const SPACE = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
  16: 64,
  20: 80,
} as const;

export const RADIUS = {
  none: 0,
  sm: 4,
  base: 6,
  md: 8,
  lg: 10,
  xl: 12,
  "2xl": 16,
  full: 999,
} as const;

export const SHADOW = {
  sm: "0 1px 2px rgba(0,0,0,0.4)",
  base: "0 4px 12px rgba(0,0,0,0.5)",
  md: "0 8px 24px rgba(0,0,0,0.55)",
  lg: "0 16px 48px rgba(0,0,0,0.6)",
  panel: "-4px 0 32px rgba(0,0,0,0.7)",
} as const;

export const MOTION = {
  fast: "120ms",
  base: "200ms",
  slow: "320ms",
  ease: "cubic-bezier(0.4, 0, 0.2, 1)",
} as const;

export const A11Y = {
  focusRing: "0 0 0 2px #7c3aed",
  skipLinkBg: "#7c3aed",
} as const;

/**
 * Width of the record-overview column on the Contact and Company detail pages, as a
 * PERCENTAGE of the available page width. Paired with `marginInline: auto` to centre it.
 *
 * Was a fixed 720px — the "extra-wide" lead drawer width the cards were designed for —
 * which left most of a wide viewport empty and stayed just as narrow no matter how large
 * the window got. A percentage tracks the viewport instead of guessing at one.
 *
 * Not 100%: some breathing room on each side keeps the cards' two-column field grids from
 * running edge to edge. If this ever sprawls on an ultrawide display, wrap it as
 * `min(${OVERVIEW_MAX_WIDTH}, 1600px)` at the call site rather than going back to a fixed
 * pixel value.
 *
 * Lives here because ContactDetailPage and the company OverviewTab both need it and used to
 * declare it separately, each with a comment telling the reader to keep it in sync with the
 * other.
 */
export const OVERVIEW_MAX_WIDTH = "88%";
